import Vue from 'vue'
import { store } from './store/_store';
// import * as VueGoogleMaps from 'vue2-google-maps'

import StoreInit from './components/StoreInit.vue'
import VueAwesomeSlider from 'vue-awesome-swiper'
import HorizontalSlider from './components/HorizontalSlider.vue'
import AddressPicker from './elements/AddressPicker.vue'
import HasManyFormWrapper from './elements/HasManyFormWrapper.vue'
import LocationPicker from './components/LocationPicker.vue'
import DocumentCategoryPicker from './components/DocumentCategoryPicker.vue'

import 'swiper/dist/css/swiper.css'

// export const GMAPS_KEY = 'AIzaSyCm68FREeiPD6dlvzTXFO-pHyIXKEjwlwo'

// Vue.use(VueGoogleMaps, {
// 	load: {
// 		key: GMAPS_KEY,
// 		libraries: 'places,geometry'
// 	}
// });


// END GLOBAL COMPONENT IMPORT

var app = new Vue({
	el: '#app',
	data: {
		items: []
	},
    store,
    components: {
		StoreInit,
		VueAwesomeSlider,
		HorizontalSlider,
		AddressPicker,
		HasManyFormWrapper,
		LocationPicker,
		DocumentCategoryPicker,
   	}
});





// WEBPACK FOOTER //
// ./assets/js/vue/main.js